import script from "./MappingCategoryUrssafBrand.vue?vue&type=script&lang=ts&setup=true"
export * from "./MappingCategoryUrssafBrand.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__